import React, { useState, useEffect, useRef } from 'react';
import ReactMapGL, { Source, Layer } from 'react-map-gl';
import { DeckGL } from '@deck.gl/react';
import { ArcLayer } from '@deck.gl/layers';
import { HexagonLayer } from '@deck.gl/aggregation-layers'; // Correct import for HexagonLayer
import mapboxgl from 'mapbox-gl';

// Your Mapbox Access Token
const MAPBOX_TOKEN = 'pk.eyJ1IjoicmFqdWltYXRpYyIsImEiOiJjbTNjbTdidnExbXQ5MmpyMWZqYXJlOThjIn0.jGxbpv2JonNR6Y6LkjfwHw'; // Replace with your Mapbox token

const Map = () => {
  const mapRef = useRef();
  const [viewport, setViewport] = useState({
    latitude: 19.0760, // Mumbai's latitude
    longitude: 72.8777, // Mumbai's longitude
    zoom: 5, // Adjusted zoom level to fit India and two locations
    pitch: 60, // Pitch for 3D effect
    bearing: 0, // Map rotation
  });

  // Locations for the two offices
  const locations = [
    { id: 'head_office', name: 'Nomad Group Head Office', latitude: 32.0609, longitude: 76.8555, address: 'Vill- Khatrod, V.P.O. Panyali, Teh- Nadaun, Distt- Hamirpur, Himachal Pradesh, INDIA. Pin - 177040.' },
    { id: 'branch_office', name: 'Nomad Bikers Branch Office', latitude: 19.0720, longitude: 72.8777, address: '21, J.K. Chambers, Sector-17, Vashi, Navi Mumbai, INDIA. Pin - 400703.' },
  ];

  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_TOKEN; // Set Mapbox Access Token
  }, []);

  // ArcLayer data - Create an arc from one office to the other
  const arcs = [
    {
      sourcePosition: [locations[0].longitude, locations[0].latitude], // Head office
      targetPosition: [locations[1].longitude, locations[1].latitude], // Branch office
      color: [255, 0, 0], // Red color for arc
      width: 2,
    },
  ];

  // HexagonLayer data (example: we'll create hexagons around each office location)
  const hexagonData = locations.map(location => ({
    position: [location.longitude, location.latitude],
  }));

  const layers = [
    // ArcLayer for visualizing the connection between the offices
    new ArcLayer({
      id: 'arc-layer',
      data: arcs,
      getSourcePosition: (d) => d.sourcePosition,
      getTargetPosition: (d) => d.targetPosition,
      getSourceColor: (d) => d.color,
      getTargetColor: (d) => d.color,
      getWidth: (d) => d.width,
      widthMinPixels: 2,
    }),

    // HexagonLayer
    new HexagonLayer({
      id: 'hexagon-layer',
      data: hexagonData,
      radius: 1000, // Hexagon radius
      getPosition: (d) => d.position,
      elevationScale: 50,
      extruded: true,
      pickable: true,
      elevationRange: [0, 1000],
      coverage: 1,
    }),
  ];

  return (
    <div style={{ height: '100vh' }}>
      <DeckGL
        initialViewState={viewport}
        controller={true}
        layers={layers}
        getTooltip={(info) => info.object ? `${info.object.position}` : ''}
      >
        <ReactMapGL
          {...viewport}
          width="100%"
          height="100%"
          mapStyle="mapbox://styles/mapbox/light-v9"
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={(nextViewport) => setViewport(nextViewport)}
          ref={mapRef}
        >
          {/* 3D buildings layer */}
          <Source type="vector" url="mapbox://mapbox.mapbox-streets-v8">
            <Layer
              id="building-layer"
              type="fill-extrusion"
              source="composite"
              source-layer="building"
              minzoom={15}
              paint={{
                'fill-extrusion-color': '#aaa',
                'fill-extrusion-height': ['get', 'height'],
                'fill-extrusion-base': ['get', 'min_height'],
                'fill-extrusion-opacity': 0.75,
              }}
            />
          </Source>
        </ReactMapGL>
      </DeckGL>
    </div>
  );
};

export default Map;
